<template>
    <div>
        <el-form :rules="rules" ref="ruleForm" :model="editData" label-width="110px" size="mini">
            <el-form-item prop="name" class="lable-width" label="模板名称">
                <el-input class="input-width"  clearable v-model="editData.name"></el-input>
            </el-form-item>
            <!--            <el-form-item prop="jsonData" class="lable-width json" label="录入内容模板">-->
            <!--                <el-input type="textarea" classS="input-width"  clearable v-model="editData.jsonData"></el-input>-->

            <!--            </el-form-item>-->

            <el-form-item class="lable-width describe" label="操作">
                <el-button type="text" @click="inputclick" style="font-size: 15px">输入框</el-button>
                <el-button type="text" @click="dcsiptclick" style="font-size: 15px">DCS输入框</el-button>
                <el-button type="text" @click="radioclick" style="font-size: 15px">单选框</el-button>
<!--                <el-button type="text" @click="dcsrdclick" style="font-size: 15px">DCS单选框</el-button>-->
                <el-button type="text" @click="checkclick" style="font-size: 15px">多选框</el-button>
                <el-button type="text" @click="textclick" style="font-size: 15px">文本框</el-button>
                <!--                <draggable-->
                <!--                        :group='{name: "menu", put: true}'-->
                <!--                        :sort="false"-->
                <!--                        :value="collections">-->
                <!--  <span v-for='collection in collections' :key='collection.id'>-->
                <!--    {{collection.fieldName}}-->
                <!--  </span>-->
                <!--                </draggable>-->


                <!--                <el-input  type="textarea"  class="input-width" clearable v-model="editData.describe"></el-input>-->
            </el-form-item>
            <el-form-item class=" describe" label="视图 " style="display: flex">
                <div style=" width:407px;padding:5px 8px;border-radius: 4px; border: 1px solid #DCDFE6;margin-left: 28px;">
                    <!--                    <draggable-->
                    <!--                            :group='{name: "menu", put: false}'-->
                    <!--                            :sort='false'-->
                    <!--                            class="draggableA"-->
                    <!--                            :value="notCollectedMenus">-->
                    <!--  <span v-for='menu in notCollectedMenus' :key='menu.id' class="aaa">-->
                    <!--   {{menu.fieldName}}-->
                    <!--  </span>-->
                    <!--                    </draggable>-->
                    <draggable   v-model="myarr" chosenClass="chosen" forceFallback="true" group="people" animation="1000" @start="onstart" @end="onend">
                        <transition-group>
                            <div style="display:flex;width: 390px;align-items: center" class="item" v-for="(val,index) in myarr" :key="index">
                                <div @mouseenter="enter1(index)" @mouseleave="leave1" v-if="val.type=='input'" style="display: flex;align-items: center;width: 100% ;">
                                <div  class="drag" style="display: flex;align-items: center">
                                    {{val.title==''?'':val.title+':'}}
                                </div>
                                <!--                                    <i @click="deltitle(index)" style="margin-left: 5px;font-size: 18px" class="el-icon-delete-solid"></i>-->
                                <div class="draggable" style="display: flex;align-items: center">
                                    <el-input style="margin-left: 5px"  placeholder="内容"  v-model="val.value"></el-input>

                                </div>
                                <!--                                    <el-button  v-if="inputdel==index" type="text" @click="iptdialog1(index)">编辑</el-button>-->
                                <i v-show="inputdel==index  " @click="iptdialog1(index)" style="color:#3e82e8;margin-left: 5px;font-size: 18px" class="el-icon-edit"></i>

                                <i v-show="inputdel==index  " @click="delmyarr(index)" style="color:#FF3333;margin-left: 10px;font-size: 18px" class="el-icon-delete-solid"></i>
                                <el-dialog
                                        width="550px"
                                        title="内层"
                                        append-to-body
                                        :close-on-click-modal="false"
                                        :visible.sync="iptdialog"
                                >
                                    <div  class="taoradio" style="display: flex">
                                        <div  class="iptinput" style="margin-right: 5px;display: flex">
                                            <el-input style="margin-right: 5px" placeholder="请输入标题" clearable  v-model="iptdata.title"></el-input>
                                        </div>
                                        ：
                                        <div  class="iptinput" style="margin-right: 5px;display: flex">
                                            <el-input style="margin-right: 5px" placeholder="请输入内容" clearable  v-model="iptdata.value"></el-input>
                                        </div>
                                    </div>

                                    <div slot="footer">
                                        <el-button @click="iptclick">取消</el-button>
                                        <el-button @click="siptclick(index)">{{$t('button_save')}}</el-button>
                                    </div>
                                </el-dialog>
                            </div>
<!--                                dcsipt-->
                                <div @mouseenter="enter6(index)" @mouseleave="leave6" v-if="val.type=='dcsInput'" style="display: flex;align-items: center;width: 100% ;">
                                    <div style="width: 260px;;border: 1px solid black;border-radius: 5px;margin-bottom: 5px;margin-right: 5px" class="dcsiii">
                                        <div  class="drag" style="border-bottom: 1px solid black;display: flex;align-items: center;padding-left: 5px;justify-content: space-between">
                                            {{val.title==''?'标题':val.title}}
                                            <div style="margin-right: 5px;" >参考标准</div>
                                        </div>

                                        <!--                                    <i @click="deltitle(index)" style="margin-left: 5px;font-size: 18px" class="el-icon-delete-solid"></i>-->
                                        <div class="draggable" style="display: flex;align-items: center">
                                            <div  style="">
                                                DCS
                                            </div>
                                           <el-input  style="margin-left: 5px"  placeholder="内容"  ></el-input>
                                            <div style="display: flex;align-items: center" v-if="val.cb==1">
                                                <div style="">表显</div>

                                                <el-input style="margin-left: 5px"  placeholder="内容"  ></el-input>

                                            </div>
                                            </div>


                                    </div>
                                    <div>
                                        <i v-show="dcsiptdel==index  " @click="delmyarr(index)" style="color:#FF3333;font-size: 18px" class="el-icon-delete-solid"></i>

<!--                                                                                <i  @click="delmyarr(index)" style="color:#FF3333;font-size: 18px" class="el-icon-delete-solid"></i>-->

                                        <el-checkbox @change="dcscheckchange(index,$event)" v-model="val.cb"
                                                     label="是否显示表显">

                                        </el-checkbox>
                                    </div>
                                    <!--                                    <el-button  v-if="inputdel==index" type="text" @click="iptdialog1(index)">编辑</el-button>-->
<!--                                    <i v-show="dcsiptdel==index  " @click="dcsiptdialog(index)" style="color:#3e82e8;margin-left: 5px;font-size: 18px" class="el-icon-edit"></i>-->

<!--                                    <el-dialog-->
<!--                                            width="500px"-->
<!--                                            title="内层"-->
<!--                                            append-to-body-->
<!--                                            :close-on-click-modal="false"-->
<!--                                            :visible.sync="dcsiptdialog1"-->
<!--                                    >-->
<!--                                        <div  class="taoradio ggg" style="border: 1px solid black;border-radius: 5px;">-->
<!--                                            <div style="border-bottom: 1px solid black;display: flex;padding: 10px">-->
<!--                                                <div style="display: flex">-->
<!--                                                    <div  lass="iptinput" style="margin-right: 5px;display: flex">-->
<!--                                                        标题:-->
<!--&lt;!&ndash;                                                        <el-input style="margin-right: 5px" placeholder="请输入标题" clearable  v-model="dcsiptd.title"></el-input>&ndash;&gt;-->
<!--                                                    </div>-->

<!--                                                    <div  class="iptinput" style="margin-right: 5px;display: flex">-->
<!--                                                        <el-input style="margin-right: 5px" placeholder="请输入内容" clearable  v-model="dcsiptd.title"></el-input>-->
<!--                                                    </div>-->
<!--                                                </div>-->

<!--                                                <div class="iptinput" style="margin-right: 5px;display: flex" v-for="(ckv,cki) in dcsiptd.option" v-if="ckv.type=='ckbz'">-->

<!--                                                    参考标准:-->
<!--                                                    <el-input style="margin-right: 5px" placeholder="请输入参考标准" clearable  v-model="ckv.value"></el-input>-->
<!--                                                    <i  @click="delbz(cki)" style="color:#FF3333;margin-left: 10px;font-size: 18px" class="el-icon-delete-solid"></i>-->

<!--                                                </div>-->
<!--&lt;!&ndash;                                                {{dcsiptd}}&ndash;&gt;-->
<!--                                                <el-button v-if="dcsiptd.ckbz==0" style="display: flex;font-size: 15px" @click="addckbz(index)" type="text">添加参考标准</el-button>-->

<!--                                            </div>-->
<!--                                            <div style="display:flex;padding: 10px" >-->
<!--                                                <div class="iptinput" style="display:flex">-->
<!--                                                    dcs:-->
<!--                                                    <el-input style="margin-right: 5px;margin-left: 10px" placeholder="请输入dcs数据" clearable  v-model="dcsiptd.dcsv"></el-input>-->

<!--                                                </div>-->
<!--                                                    <div class="iptinput" style="display:flex" v-for="(cbv,cbi) in dcsiptd.option" v-if="cbv.type=='cb'">-->
<!--                                                        抄表:-->
<!--                                                        <el-input style="margin-right: 5px;margin-left: 10px" placeholder="请输入抄表数据" clearable  v-model="cbv.value"></el-input>-->
<!--                                                        <i  @click="delcb(cbi)" style="color:#FF3333;margin-left: 10px;font-size: 18px" class="el-icon-delete-solid"></i>-->

<!--                                                    </div>-->
<!--                                                <el-button v-if="dcsiptd.cb==0" style="display: flex;font-size: 15px" @click="addcb(index)" type="text">添加抄表</el-button>-->

<!--                                            </div>-->
<!--                                            <div>-->

<!--                                            </div>-->
<!--                                        </div>-->

<!--                                        <div slot="footer">-->
<!--                                            <el-button @click="cdcsiptclick">取消</el-button>-->
<!--                                            <el-button @click="sdcsiptclick(index)">保存</el-button>-->
<!--                                        </div>-->
<!--                                    </el-dialog>-->
                                </div>
<!--                                wenbenkuang-->
                                <div @mouseenter="enter5(index)" @mouseleave="leave5" v-if="val.type=='textarea'" style="display: flex;width: 100% ;">
                                    <div  class="drag" style="display: flex;">
                                        {{val.title==''?'':val.title+':'}}
                                        <!--                                        <el-input placeholder="标题" v-model="val.title"></el-input>-->
                                        <!--                                        <span >:</span>-->
                                        <!--                                        <i v-show="inputdel==index  " @click="delcha1(index)" style="margin-left: 5px;font-size: 18px" class="el-icon-delete-solid"></i>-->

                                    </div>
                                    <!--                                    <i @click="deltitle(index)" style="margin-left: 5px;font-size: 18px" class="el-icon-delete-solid"></i>-->
                                    <div class="draggable" style="display: flex;align-items: center">
                                        <el-input style="margin-left: 5px" type="textarea" placeholder="内容"  v-model="val.value"></el-input>

                                    </div>
                                    <!--                                    <el-button  v-if="inputdel==index" type="text" @click="iptdialog1(index)">编辑</el-button>-->
                                    <i v-show="textdel==index  " @click="textdialog(index)" style="color:#3e82e8;margin-left: 5px;font-size: 18px" class="el-icon-edit"></i>

                                    <i v-show="textdel==index  " @click="delmyarr(index)" style="color:#FF3333;margin-left: 10px;font-size: 18px" class="el-icon-delete-solid"></i>
                                    <el-dialog
                                            width="450px"
                                            title="内层"
                                            append-to-body
                                            :close-on-click-modal="false"
                                            :visible.sync="textdog"
                                    >
                                        <div  class="taoradio" style="display: flex">
                                            <div  class="iptinput" style="margin-right: 5px;display: flex">
                                                <el-input style="margin-right: 5px" placeholder="请输入标题" clearable  v-model="textdata.title"></el-input>
                                            </div>
                                            ：
                                            <div  class="iptinput" style="margin-right: 5px;display: flex">
                                                <el-input style="margin-right: 5px" placeholder="请输入内容" type="textarea" clearable  v-model="textdata.value"></el-input>
                                            </div>
                                        </div>

                                        <div slot="footer">
                                            <el-button @click="cttclick">取消</el-button>
                                            <el-button @click="sttclick(index)">{{$t('button_save')}}</el-button>
                                        </div>
                                    </el-dialog>
                                </div>
<!--                                dcsdanxuankuang-->
                                <div  style="display: flex;width: 100%;align-items: center" @mouseenter="enter7(index)" @mouseleave="leave7" v-if="val.type=='dcsRadio'">
                                    <div class="radiodra" style="display: flex">
                                        <!--                                        <el-input placeholder="标题" v-model="val.title"></el-input>-->
                                        {{val.title==''?'':val.title+':'}}
                                    </div>

                                    <div  style="display:flex;align-items: center;"  class="radio">
                                        <el-radio-group v-model="newarr2" style="display:flex ">
                                            <el-radio @input="radioinput($event,index,radioindex)" v-for="(radioval,radioindex) in val.option" :key="radioindex"
                                                      :label="radioval.value==''?'单选框':radioval.value">
                                                <!--                                                <el-input placeholder="内容" v-model="radioval.value"></el-input>-->

                                            </el-radio>
                                        </el-radio-group>

                                    </div>
                                    <i v-show="dcsrddel==index  " @click="dcsrddialog(index)" style="color:#3e82e8;margin-left: 5px;font-size: 18px" class="el-icon-edit"></i>

                                    <!--                                    <el-button  v-if="radiodel==index" type="text" @click="radiodialog(index)">编辑</el-button>-->
                                    <i v-show="dcsrddel==index  " @click="delmyarr(index)" style="color:#FF3333;margin-left: 10px;font-size: 18px" class="el-icon-delete-solid"></i>

                                    <el-dialog
                                            width="850px"

                                            title="内层"
                                            append-to-body
                                            :close-on-click-modal="false"
                                            :visible.sync="dcsrddialog1"
                                    >
                                        <div style="display: flex" class="taoradio">
                                            <div  class="taoinput" style="margin-right: 5px;display: flex">
                                                <el-input style="margin-right: 5px" placeholder="标题"   v-model="dcsrdd.title"></el-input>:
                                            </div>
                                            <draggable  v-model="dcsrdd.option" chosenClass="chosen" forceFallback="true" group="people" animation="1000" >
                                                <transition-group style="display:flex;;flex-wrap: wrap">
                                                    <div  v-for='(radio1val,radio1index) in dcsrdd.option' :key='radio1index' class="aaa" >
                                                        <el-radio-group   v-model="newarr3" style="display:flex;align-items: center ">
                                                            <el-radio   @input="radioinput($event,index,radio1index)"
                                                                      :label="radio1val.value==''?'单选框':radio1val.value">
                                                                <el-input placeholder="内容" v-model="radio1val.value"></el-input>

                                                            </el-radio>
                                                            <i @click="dcsdelradio1(index,radio1index)" style="color:#FF3333;font-size: 18px" class="el-icon-delete-solid"></i>
                                                        </el-radio-group>
                                                    </div>
                                                </transition-group>
                                            </draggable>
                                            <el-button style="display: flex;font-size: 15px" @click="dcsaddradio(index)" type="text">添加</el-button>
                                        </div>

                                        <div slot="footer">
                                            <el-button @click="cdcsrdclick">取消</el-button>
                                            <el-button @click="sdcsrdclick(index)">{{$t('button_save')}}</el-button>
                                        </div>
                                    </el-dialog>


                                </div>
<!--                                danxuankuang-->
                                <div  style="display: flex;width: 100%;align-items: center" @mouseenter="enter2(index)" @mouseleave="leave2" v-if="val.type=='radio'">
                                    <div class="radiodra" style="display: flex">
<!--                                        <el-input placeholder="标题" v-model="val.title"></el-input>-->
                                    {{val.title==''?'':val.title+':'}}
                                    </div>

                                    <div  style="display:flex;align-items: center;"  class="radio">
                                        <el-radio-group v-model="newarr" style="display:flex ">
                                            <el-radio @input="radioinput($event,index,radioindex)" v-for="(radioval,radioindex) in val.option" :key="radioindex"
                                                      :label="radioval.value==''?'单选框':radioval.value">
<!--                                                <el-input placeholder="内容" v-model="radioval.value"></el-input>-->

                                            </el-radio>
                                        </el-radio-group>

                                    </div>
                                    <i v-show="radiodel==index  " @click="radiodialog(index)" style="color:#3e82e8;margin-left: 5px;font-size: 18px" class="el-icon-edit"></i>

<!--                                    <el-button  v-if="radiodel==index" type="text" @click="radiodialog(index)">编辑</el-button>-->
                                    <i v-show="radiodel==index  " @click="delmyarr(index)" style="color:#FF3333;margin-left: 10px;font-size: 18px" class="el-icon-delete-solid"></i>

                                    <el-dialog
                                            width="850px"

                                     title="内层"
                                     append-to-body
                                     :close-on-click-modal="false"
                                     :visible.sync="taodialog"
                                    >
                                        <div style="display: flex" class="taoradio">
                                            <div  class="taoinput" style="margin-right: 5px;display: flex">
                                                <el-input style="margin-right: 5px" placeholder="标题"   v-model="taodata.title"></el-input>:
                                            </div>
                                            <draggable  v-model="taodata.option" chosenClass="chosen" forceFallback="true" group="people" animation="1000" >
                                                <transition-group style="display:flex;;flex-wrap: wrap">
                                                         <div  v-for='(radio1val,radio1index) in taodata.option' :key='radio1index' class="aaa" >
                                                             <el-radio-group   v-model="newarr1" style="display:flex;align-items: center ">
                                                                 <el-radio @mouseenter="enter4" @mouseleave="leave4"  @input="radioinput($event,index,radio1index)"
                                                                           :label="radio1val.value==''?'单选框':radio1val.value">
                                                                                                                 <el-input placeholder="内容" v-model="radio1val.value"></el-input>

                                                                 </el-radio>
                                                                 <i @click="delradio1(index,radio1index)" style="color:#FF3333;font-size: 18px" class="el-icon-delete-solid"></i>
                                                             </el-radio-group>
                                                         </div>
                                                </transition-group>
                                            </draggable>
                                            <el-button style="display: flex;font-size: 15px" @click="addradio(index)" type="text">添加</el-button>
                                            </div>

                                        <div slot="footer">
                                            <el-button @click="rdclick">取消</el-button>
                                            <el-button @click="srdclick(index)">{{$t('button_save')}}</el-button>
                                        </div>
                                    </el-dialog>


                                </div>

                                <div  @mouseenter="enter3(index)" @mouseleave="leave3" style="width: 100%;margin:4px 0px 0 0;align-items: center;display: flex;
flex-wrap: wrap" v-if="val.type=='checkbox'" >
                                    <div class="checkdra" style="display: flex;align-items: center">

<!--                                        <el-input placeholder="标题" v-model="val.title"></el-input>-->
                                        {{val.title==''?'':val.title+':'}}
                                        <i v-show="checkdel==index  " @click="checkdialog(index)" style="color:#3e82e8;margin-left: 5px;font-size: 18px" class="el-icon-edit"></i>

                                        <!--                                        <el-button v-if="checkdel==index"  style="margin-left:20px"  type="text" @click="checkdialog(index)">编辑</el-button>-->
                                        <i v-show="checkdel==index  " @click="delmyarr(index)" style="color:#FF3333;margin-left: 10px;font-size: 18px" class="el-icon-delete-solid"></i>

                                    </div>

                                    <div  style="width: 100%;display: flex;flex-wrap: wrap;margin-right: 25px" class="checkbox">

                                        <el-checkbox @change="checkchange(index,checkval,$event)" v-for="(checkval,checkindex) in val.option" :key="checkindex"
                                                     :label="checkval.value==''?'多选框':checkval.value">
<!--                                            <el-input placeholder="内容" v-model="checkval.value"></el-input>-->

                                        </el-checkbox>

                                    </div>
                                    <el-dialog
                                            width="450px"
                                            title="内层"
                                            append-to-body
                                            :close-on-click-modal="false"
                                            :visible.sync="ckdialog"
                                    >
                                        <div  class="taoradio">
                                            <div  class="taoinput" style="margin-right: 5px;display: flex;margin-bottom: 8px">
                                                <el-input style="margin-right: 5px" placeholder="标题"   v-model="ckdata.title"></el-input>:
                                            </div>
                                            <draggable  v-model="ckdata.option" chosenClass="chosen" forceFallback="true" group="people" animation="1000" >
                                                <transition-group style="display:flex;;flex-wrap: wrap">
                                                    <div  v-for='(check1val,check1index) in ckdata.option' :key='check1index' class="bbb" style="margin-bottom:8px">
                                                        <el-checkbox @change="checkchange(index,check1val,$event)"
                                                                     :label="check1val.value==''?'多选框':check1val.value">
                                                                                                        <el-input placeholder="内容" v-model="check1val.value"></el-input>

                                                        </el-checkbox>
<!--                                                        <el-radio-group   v-model="newarr1" style="display:flex;align-items: center ">-->
<!--                                                          -->
                                                            <i @click="delcheck1(index,check1index)" style="color:#FF3333;margin-left: 30px;font-size: 18px" class="el-icon-delete-solid"></i>
<!--                                                        </el-radio-group>-->
                                                    </div>
                                                </transition-group>
                                            </draggable>
                                            <el-button style="display: flex;font-size: 15px" @click="addcheck(index)" type="text">添加</el-button>
                                        </div>

                                        <div slot="footer">
                                            <el-button @click="ckclick">取消</el-button>
                                            <el-button @click="sckclick(index)">{{$t('button_save')}}</el-button>
                                        </div>
                                    </el-dialog>
                                    <!--                                    <div>-->
<!--                                        <div v-for="(checkval,checkindex) in val.option" :key="checkindex">-->
<!--                                            <i @click="delcheck(index,checkindex)" style="  font-size: 18px" class="el-icon-delete-solid"></i>-->
<!--                                            <i @click="addradio(index,checkindex)" style="margin-left: 5px;font-size: 18px" class="el-icon-plus"></i>-->

<!--                                        </div>-->
<!--                                    </div>-->

<!--                                    <i @click="delmyarr(index)" style="margin-top:4px;font-size: 18px;height: 28px" class="el-icon-delete-solid"></i>-->


                                </div>
                            </div>
                        </transition-group>
                    </draggable>
                </div>
            </el-form-item>
            <el-form-item class="lable-width describe" label="描述">
                <el-input  type="textarea"  class="input-width" clearable v-model="editData.describe"></el-input>
            </el-form-item>
            <!--            <el-form-item  class="slable-width" label="描述">-->
            <!--                <el-input class="sinput-width"  clearable v-model="editData.nextType"></el-input>-->

            <!--            </el-form-item>-->
            <el-form-item class="lable-width" label="录入人">
                <el-input class="input-width" disabled clearable v-model="editData.lruName"></el-input>
            </el-form-item>
            <el-form-item prop="creatTime" class="lable-width" label="创建时间">
                <el-input class="input-width"  disabled v-model="editData.creatTime"></el-input>

            </el-form-item>


            <!--            <el-form-item class="lable-width" label="描述">-->
            <!--                <el-input  type="textarea"  class="input-width" clearable v-model="editData.describe"></el-input>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item prop="consumerName" class="lable-width" label="消费服务名称">-->
            <!--                <el-select class="input-width" v-model="editData.consumerName" placeholder="请选择消费服务名称">-->
            <!--                    <el-option v-for="val in consumername" :key="val.id" :label="val.name" :value="val.name"></el-option>-->
            <!--                </el-select>-->
            <!--            </el-form-item>-->

            <!--            <el-form-item class="lable-width" label="创建时间">-->
            <!--                <el-input class="input-width" disabled clearable v-model="editData.createTime"></el-input>-->
            <!--            </el-form-item>-->
            <el-form-item  label="是否启用">
                <div style="margin-left: 78px">
                    <el-radio v-model="editData.state" :label="1">启用</el-radio>
                    <el-radio v-model="editData.state" :label="0">不启用</el-radio>
                </div>
            </el-form-item>
            <!--            <el-form-item  label="是否继续">-->
            <!--                <div style="margin-left: 46px">-->
            <!--                    <el-radio v-model="editData.isNext" :label="1">是</el-radio>-->
            <!--                    <el-radio v-model="editData.isNext" :label="0">否</el-radio>-->
            <!--                </div>-->
            <!--            </el-form-item>-->
            <el-form-item class="lable-width" style="margin-left: 0">
                <el-button style="margin-left: 0" type="primary" @click="onSubmit(editData)">{{$t('button_save')}}</el-button>
                <el-button type="primary" @click="close">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import * as API from "../api";
    import {mapActions} from "vuex";
    import draggable from "vuedraggable"
    import $ from 'jquery';
    export default {
        name: 'reviseTemplate',
        components:{
            draggable
        },
        props:{

            editData:{
                type:Object
            }
        },
        data(){
            return{
                dcsipti:0,
                dcsiptd:'',
                dcsrdi:0,
                dcsrdd:'',
                dcsiptdialog1:false,
                dcsrddialog1:false,
                iptdialog:false,
                iptdata:'',
                ckindex:0,
                rdindex:0,
                textdata:'',
                iptindex:0,
                ckdialog:false,
                ckdata:'',
                dcsiptp:1,
                taodialog:false,
                openinput:false,
                radiodel:'a',
                // checkdel:false,
                checkdel:'a',
                inputdel:'a',
                textdel:'a',
                dcsiptdel:'a',
                dcsrddel:'a',
                radiovalue:9999,
                newarr:'',
                newarr1:'',
                newarr2:'',
                newarr3:'',
                cha1:false,
                myarr1:[],
                myarr2:[{
                    value:'1'
                },{
                    value:'2'
                },{
                    value:'3'
                },],

                a:1,
                textindex:0,
                textdog:false,
                myarr:[

                ],
                taodata:''

                ,
                consumername:[],
                rules: {
                    name: [
                        { required: true, message: '请输入模板名称', trigger: 'blur' },

                    ],
                    jsonData: [
                        { required: true, message: '请输入录入内容模板', trigger: 'blur' }
                    ],


                }
            }
        },
        watch:{
        },
        mounted(){
            // this.getConsumerServerDropDownList()
            // console.log(       )
            if(this.editData.jsonData!==''){
                this.myarr=JSON.parse(this.editData.jsonData)

            }else{
                this.myarr=[]
            }
            // if(this.editData.id!==0){
            //     // this.editData.id=1
            // }
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            addtitle(){
this.openinput=!this.openinput
            },
            switchclick(){

                // console.log(this.textdata)
                // console.log(this.myarr[this.textindex])
            },
            textdialog(index){
                // console.log(1)
                let add=JSON.parse(JSON.stringify(this.myarr[index]))
                this.textdata=add
                // console.log(add)
                this.textdog=true
                this.textindex=index
            },
            checkdialog(index){
                let add=JSON.parse(JSON.stringify(this.myarr[index]))
                this.ckdata=add
                // console.log(add)
                this.ckdialog=true
                this.ckindex=index
            },
            iptdialog1(index){
                // console.log(index)

                let add=JSON.parse(JSON.stringify(this.myarr[index]))
                this.iptdata=add
                this.iptdialog=true
                this.iptindex=index
            },
            dcsiptdialog(index){
                // console.log(this.myarr)

                let add=JSON.parse(JSON.stringify(this.myarr[index]))
                this.dcsiptd=add
                this.dcsiptdialog1=true
                this.dcsipti=index
                // console.log(this.dcsiptd)
            },
            dcsrddialog(index){
                // console.log(index)

                let add=JSON.parse(JSON.stringify(this.myarr[index]))
                this.dcsrdd=add
                this.dcsrddialog1=true
                this.dcsrdi=index
            },
            radiodialog(index){
                    let add=JSON.parse(JSON.stringify(this.myarr[index]))
                this.taodata=add
              this.taodialog=true
                this.rdindex=index
            },
            enter4(){
                this.cha1=!this.cha1
            },
            leave4(){
                this.cha1=!this.cha1

            },
            enter3(i){
                this.checkdel=i
            },

            leave3(){
                this.checkdel='a'
            },
            enter5(i){
                this.textdel=i
            },

            leave5(){
                this.textdel='a'
            },
            enter6(i){
                this.dcsiptdel=i
            },

            leave6(){
                this.dcsiptdel='a'
            },
            enter7(i){
                this.dcsrddel=i
            },

            leave7(){
                this.dcsrddel='a'
            },
            enter2(i){
                this.radiodel=i
            },

            leave2(){
                this.radiodel='a'
            },
            iptclick(){
                this.iptdialog=false

            },
            cdcsiptclick(){
                this.dcsiptdialog1=false

            },
            sdcsiptclick(i){
                this.dcsiptdialog1=false
                this.myarr[this.dcsipti]=this.dcsiptd

            },
            cdcsrdclick(){
                this.dcsrddialog1=false

            },
            sdcsrdclick(i){
                this.dcsrddialog1=false
                this.myarr[this.dcsrdi]=this.dcsrdd

            },
            cttclick(){
                this.textdog=false

            },
            sttclick(i){
                this.textdog=false
                this.myarr[this.textindex]=this.textdata
            },
            siptclick(i){
                // console.log(i)
                this.iptdialog=false
                this.myarr[this.iptindex]=this.iptdata

            },
            ckclick(){
                this.ckdialog=false
            },
            sckclick(i){
                this.ckdialog=false
                this.myarr[this.ckindex]=this.ckdata
            },
            rdclick(){
                this.taodialog=false
            },
            srdclick(i){
                this.myarr[this.rdindex]=this.taodata
                this.taodialog=false

            },
            enter1(i){
                this.inputdel=i
            },
            delcha1(i){
            },
            leave1(){
                this.inputdel='a'
            },
            radioinput(e,i,ri){
                // console.log(e)
                // this.myarr[i].value=this.myarr[i].option[e].value
                // console.log(this.myarr[i].value)
            },
            dcscheckchange(e,i){
                if(i==false){
                    this.myarr[e].cb=false
                }else{
                    this.myarr[e].cb=true

                }
              // console.log(e,i)
            },
            checkchange(el,e,event){
                this.$set(e,'check',event)
                let add=this.myarr[el].option.filter(item=>{return item.check==true})
                let abc=add.map(item=>{
                    return item.value
                })
                abc=abc.join(',')
                this.myarr[el].value=abc
                // console.log(abc)
                // console.log(this.myarr[el])
                // this.$set(this.myarr[el].option[e],'checked','true')
                // this.myarr[el].option.push(add)
                // console.log(this.myarr[el].option)
            },
            addcheck(i){
                let length=this.myarr[i].option.length-1
                length=length+1
                var add={
                    id:length,
                    value:''
                }
                this.ckdata.option.push(add)
            },
            addcb(i){

                var add={
                    type:'cb',
                    value:''
                }
                this.dcsiptd.option.push(add)
                this.dcsiptd.cb=1
            },
            addckbz(i){

                var add={
                    type:'ckbz',
                    value:''
                }
                this.dcsiptd.option.push(add)
                this.dcsiptd.ckbz=1


            },
            addradio(i,index){
                let length=this.myarr[i].option.length-1
                length=length+1
                var add={
                    id:length,
                    value:''
                }
                    this.taodata.option.push(add)
            },
            delbz(i){
              this.dcsiptd.option.splice(i,1)
                this.dcsiptd.ckbz=0
            },
            delcb(i){
                this.dcsiptd.option.splice(i,1)
                this.dcsiptd.cb=0

            },
            dcsaddradio(i,index){
                let length=this.myarr[i].option.length-1
                length=length+1
                var add={
                    id:length,
                    value:''
                }
                this.dcsrdd.option.push(add)
            },
            delradio1(index,i){
                this.taodata.option.splice(i,1)
            },

            dcsdelradio1(index,i){
                this.dcsrdd.option.splice(i,1)
            },
            delcheck1(index,i){
                this.ckdata.option.splice(i,1)

            },
            delradio(index,i){
                this.myarr[index].option.splice(i,1)
                // console.log(this.myarr[index].option.length)
                if(this.myarr[index].option.length==0){
                    this.myarr.splice(index,1 )

                }
            },
            delcheck(index,i){
                this.myarr[index].option.splice(i,1)
                // console.log(this.myarr[index].option.length)
                if(this.myarr[index].option.length==0){
                    this.myarr.splice(index,1 )

                }
            },
            onstart(){
                // console.log(11)
                //
            },
            onend(){
                // console.log(111)

            },
            deltitle(i){

            },
            delmyarr(i){
                // console.log(i)
                this.myarr.splice(i,1 )
                // this.radiodel=false
            },
            inputclick(){
                let add={
                    type:'input',
                    // switch:'0'
                    title:'',
                    value:'',
                    option:[]
                }
                this.$nextTick(()=>{
                    this.myarr.push(add)

                })
                // console.log(this.myarr)
            },
            dcsiptclick(){
                let add=[]
                this.myarr.forEach(item=>{
                    if(item.type=='dcsInput'){
                        add.push(item)
                    }
                })
                if(add.length>=1){

                }else {
                    let abc={
                        type:'dcsInput',
                        // switch:'0'
                        title:'',
                        value:'',
                        cb:true,
                        option:[]
                    }
                    this.$nextTick(()=>{
                        this.myarr.push(abc)

                    })
                }

            },
            dcsrdclick(){
                let add={
                    type:'dcsRadio',
                    title:'',
                    value:'',
                    option:[{
                        id:0,
                        value:'',
                    }]
                }
                this.$nextTick(()=>{
                    this.myarr.push(add)

                })
            },
            radioclick(){

                let add={
                    type:'radio',
                    title:'',
                    value:'',
                    option:[{
                        id:0,
                        value:'',
                    }]
                }
                this.$nextTick(()=>{
                    this.myarr.push(add)

                })
                // this.$forceUpdate()
            },
            textclick(){
                let add={
                    type:'textarea',
                    title:'',
                    value:'',
                    option:[]
                }
                this.$nextTick(()=>{
                    this.myarr.push(add)

                })
            },
            checkclick(){
                let add={
                    type:'checkbox',
                    title:'',
                    value:'',
                    option:[{
                        id:0,
                        value:'',
                        // checked:false,

                    }]
                }
                this.$nextTick(()=>{
                    this.myarr.push(add)

                })
                // console.log(11111)
            },
            //业务配置保存
            async addTemplate() {

                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.editData.id,
                    name:this.editData.name,
                    jsonData:JSON.stringify(this.myarr),
                    describe:this.editData.describe,
                    lruid:this.editData.lruid,
                    lruName:this.editData.lruName,
                    state:this.editData.state
                    // isNext:this.editData.isNext
                }
                // console.log(params)
                // return
                let res = await API.addTemplate(params);
                if (res.code == 1) {
                    this.$emit('getTemplatesList')
                    this.$emit('close')
                    this.$message({
                        message: res.message,
                        type: 'success'
                    });

                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message({
                        message:res.message,
                        type:'warning'
                    })
                    // this.$message.error(res.message);
                }
            },
            close(){
                this.$emit('close')
            },

            onSubmit(editData){
//获取对应ID
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        // console.log(this.editData.xfname)

                        // let add1=this.consumername.filter(item=>{
                        //     return  item.name==this.editData.consumerName
                        // })
                        // this.myarr.forEach(item=>{
                        //     item.option.map(i=>({
                        //         value:i.value
                        //     }))
                        // })
                        // console.log(this.myarr)

                        // this.editData.consumerId=add1[0].id
                        this.addTemplate()
                    } else {
                        // console.log('error submit!!');
                        return false;
                    }
                });


            },


        }
    }
</script>
<style lang="scss" scoped>
    /deep/{
        .aaa{
            display: flex;
            align-items: center;
            margin-right: 5px;
        }
        .bbb{
            display: flex;
            align-items: center;
        }
        .aaa .el-radio__label{
            display: inline-block;
            width: 92px !important;
        }
        .aaa .el-input__inner{
            width: 90px !important;
        }
        .el-checkbox__label{
            padding-left: 5px !important;
        }

        .checkbox .el-input--mini{
            width:167px ;
        }
        .el-radio:last-child{
            margin-right: 10px !important;
        }
        .el-checkbox{
            /*width: 189px !important;*/
            width: 100%;
        }
        .el-checkbox__label{
            display: inline-grid;
            width: 100%;

            white-space: pre-line;
            word-wrap:break-word ;
        }
        .el-cascader-node>.el-radio, .el-radio:last-child{
            margin-right: 25px !important;
        }
        /*.el-radio{*/
        /*margin-right: 0 !important;*/
        /*}*/
        .draggable{
            display: flex;
            padding: 3px;
            align-items: center;
        }
        .checkdra .el-checkbox__input{
            margin-left: 4px !important;
        }
        .taoinput .el-input__inner{
            width: 120px !important;
            display: inline-block !important;
        }
        .checkbox .el-checkbox__label{
            color: black;
        }
        .checkdra{
            color: black;

        }
        .el-radio__label{
            color: black;

        }
        .iptinput .el-input__inner{
            width: 140px !important;
            display: inline-block !important;
        }
        .checkdra .el-input__inner{
            width: 120px !important;
            display: inline-block !important;
        }
        .el-checkbox__label{
            padding-left: 10px !important;
        }
        .checkbox .el-input__inner{
            width: 157px !important;
        }
        .radio .el-input__inner{
            width: 70px !important;
            display: inline-block !important;
        }
        .radiodra .el-input__inner{
            width: 90px !important;
            display: inline-block !important;
        }
        .drag{
            color: black;
        }
        .radiodra{
            color: black;
        }
        .radio .el-input{
            width: inherit !important;
        }
        .radio .el-radio{
            margin-right: 15px;
        }
        .taoradio .el-radio{
            margin-right: 15px;

        }
        .drag .el-input__inner{
            /*color: black !important;*/
            width: 90px !important;
            display: inline-block !important;
        }
        .draggable .el-input__inner{

            width: 150px !important;
            display: inline-block !important;
        }
        .lable-width .el-form-item__content{
            margin-left: 0 !important;
        }
        .el-textarea__inner{
            height: 100px !important;
            color: #000000 !important;
            /*font-weight: 600 !important;*/
            font-size: inherit !important;
        }
        .el-form-item__error{
            left: 50% !important;
        }
    }
    .lable-width{
        text-align: center;
    }
    .slable-width{

    }
    /deep/.dcsiii .el-input__inner{
        width: 90px !important;
    }
    /deep/.dcsiii .el-input{
        width: inherit;
    }
    .dialog-footer{
        display: flex;
        justify-content: center;
        align-items: center;
        /*text-align: center;*/
        margin-top: 12px;
    }
    .input-width{
        /*text-align: center;*/
        width: 18.571rem;
    }
    .sinput-width{
        width: 150px;
        margin-left: 28px;
    }
    /deep/.json .el-textarea__inner{
        height: 180px !important;
    }
    /deep/.describe .el-textarea__inner{
        height: 80px !important;

    }
    /deep/.ggg .el-input{
        width: inherit;
    }
    /deep/.describe .el-form-item__content{
        margin-left: 0px !important;

    }
</style>